var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-524 -1242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    transform: "translate(524 1242)",
    fill: "none",
    stroke: "#070707",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_8542016_fax_office_icon",
    "data-name": "8542016_fax_office_icon",
    d: "M27.261,9.087v-4.7A1.817,1.817,0,0,0,26.729,3.1L24.159.532A1.817,1.817,0,0,0,22.874,0H9.087A1.817,1.817,0,0,0,7.27,1.817V27.261a1.817,1.817,0,0,0,1.817,1.817H27.261a1.817,1.817,0,0,0,1.817-1.817V10.9A1.817,1.817,0,0,0,27.261,9.087Zm-10.9,15.448a.909.909,0,0,1-.909.909H13.631a.909.909,0,0,1-.909-.909V22.718a.909.909,0,0,1,.909-.909h1.817a.909.909,0,0,1,.909.909Zm0-7.27a.909.909,0,0,1-.909.909H13.631a.909.909,0,0,1-.909-.909V15.448a.909.909,0,0,1,.909-.909h1.817a.909.909,0,0,1,.909.909Zm7.27,7.27a.909.909,0,0,1-.909.909H20.9a.909.909,0,0,1-.909-.909V22.718a.909.909,0,0,1,.909-.909h1.817a.909.909,0,0,1,.909.909Zm0-7.27a.909.909,0,0,1-.909.909H20.9a.909.909,0,0,1-.909-.909V15.448a.909.909,0,0,1,.909-.909h1.817a.909.909,0,0,1,.909.909Zm0-6.361H10.9V3.635h9.087V6.361a.909.909,0,0,0,.909.909h2.726ZM3.635,7.27H1.817A1.817,1.817,0,0,0,0,9.087V27.261a1.817,1.817,0,0,0,1.817,1.817H3.635a1.817,1.817,0,0,0,1.817-1.817V9.087A1.817,1.817,0,0,0,3.635,7.27Z",
    transform: "translate(546.461 1264.461)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.73d5c225a757015c120b8f5654450814.svg";
export { ForwardRef as ReactComponent };